export default "__VITE_ASSET__d0598fdc__"